


















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { randomId } from "@/utils";
import DatePicker from "vuejs-datepicker";
import { DateTimeSpan } from "@/store/modules/enums";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class DateRangePopover extends Vue {
  @Prop(String) readonly toggleType!: string;
  @Prop(String) readonly toggleLabel!: string;
  @Prop() readonly toggleClass!: any;
  @Prop() readonly toggleStyle!: any;
  @Prop(String) readonly saveButtonIcon!: string;
  @Prop(String) readonly saveButtonLabel!: string;
  @Prop(String) readonly title!: string;
  @Prop() readonly initTimeSpan!: string;
  @Prop() readonly initDateFrom!: any;
  @Prop() readonly initDateTo!: any;
  @Prop() readonly showTomorrow!: boolean;  
  @Prop() readonly showLast7Days!: boolean;
  id = "date-range-popover";
  target = `date-range-popover-target-${randomId(6)}`;
  timeSpan: string | null = null;
  dateFrom: any | null = null;
  dateTo: any | null = null;
  show = false;
  shown() {
    this.timeSpan = this.initTimeSpan;
    this.dateFrom = this.initDateFrom;
    this.dateTo = this.initDateTo;
  }
  setTimeSpan(span: DateTimeSpan) {
    this.timeSpan = span;
    this.dateFrom = null;
    this.dateTo = null;
    this.save();
  }
  save() {
    this.$emit("selected", this.timeSpan, this.dateFrom, this.dateTo);
    this.close();
  }
  clear() {
    this.timeSpan = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.$emit("selected", null, null, null);
    this.close();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  get DateTimeSpan() {
    return DateTimeSpan;
  }
  mounted() {
    this.shown();
  }
}
